import {
  BgColorsOutlined,
  SafetyCertificateOutlined,
  TruckOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';

const icons = {
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  BgColorsOutlined: <BgColorsOutlined />,
  TruckOutlined: <TruckOutlined />,
  TeamOutlined: <UserSwitchOutlined />,
};

const ThirdSection = ({data}) => {
  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 px-5 lg:py-20 py-10 '}>
      <div className={'max-w-7xl w-full'} data-aos={'fade-up'}>
        <div className={'w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-primary-900'}>{data.title}</h1>
          <p className={'playfair-display-medium lg:text-2xl text-lg mt-3 pb-4 '}>{data.description}</p>
        </div>
        
        <div className={'grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 xl:gap-10 mt-5'}>
          {data.ThirdSectionCard.map((card, index) => (
              
            <div
              key={index}
              className={'w-full shadow-md min-h-[250px] rounded-2xl flex flex-col bg-primary-50'}
            > 
              <h5 className={'text-5xl text-wrap text-center font-semibold text-primary-800 pt-4'}>{icons[card.logo]}</h5>
              <h5 className={'text-xl text-wrap text-center font-serif font-semibold py-2'}>
                {card.title}
              </h5>
              {/* <Divider className={'my-1 border-black'} /> */}
              <p className={'p-4'}>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ThirdSection.propTypes = {
  data: PropTypes.shape,
};

export default ThirdSection;
